import axios from 'axios'

const TOKEN_KEY = 'access_token'
const ACTIVE_ORG_KEY = 'active_org_id'
const SUPERADMIN_KEY = 'is_superadmin'
const API_BASE_URL =
    import.meta.env.VITE_API_BASE_URL ??
    (import.meta.env.DEV ? '/api' : '/api')

const client = axios.create({
  baseURL: API_BASE_URL,
})

export const getToken = () => localStorage.getItem(TOKEN_KEY)
export const getActiveOrgId = () => {
  const value = localStorage.getItem(ACTIVE_ORG_KEY)
  if (value === null || value === '') return null
  return value
}

export const getIsSuperAdmin = () => localStorage.getItem(SUPERADMIN_KEY) === 'true'

export const setSuperAdmin = (value) => {
  localStorage.setItem(SUPERADMIN_KEY, value ? 'true' : 'false')
}

export const clearSuperAdmin = () => {
  localStorage.removeItem(SUPERADMIN_KEY)
}

export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token)
}

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY)
}


client.interceptors.request.use((config) => {
  const token = getToken()
  const activeOrgId = getActiveOrgId()
  const isSuperAdmin = getIsSuperAdmin()
  const requestUrl = String(config?.url || '')

  const isGlobalEndpoint = requestUrl.startsWith('/organizations')

  const isOrgOptionalEndpoint =
    requestUrl.startsWith('/auth/') ||
    requestUrl === '/health' ||
    requestUrl === '/' ||
    requestUrl === '/organizations/my' ||
    isGlobalEndpoint


  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  if (!isGlobalEndpoint && activeOrgId) {
    config.headers['X-Org-Id'] = String(activeOrgId)
  }

  if (!activeOrgId && !isOrgOptionalEndpoint && !isSuperAdmin) {
    console.warn('[api] activeOrgId is missing for request:', requestUrl)
    return Promise.reject(new Error('Missing org context'))
  }

  return config
})

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      console.warn('[api] AUTH_401', { url: error?.config?.url ?? 'unknown' })
      clearToken()
      clearSuperAdmin()

      try {
        const { useAuthStore } = await import('../stores/auth.js')
        const authStore = useAuthStore()
        authStore.logout()
      } catch (logoutError) {
        console.error('[api] Failed to propagate 401 logout to auth store', logoutError)
      }
    }

    return Promise.reject(error)
  },
)

export default client

